import { type Unit, type Nil, convertUnit, getDisplayUnitAndSymbol, UserPreferredUnit } from '@core';
import { SwingAnalysis } from '@data';

export const getDisplayValue = (
    userPreferredUnit: UserPreferredUnit,
    parameterID: string,
    parameterUnit: Unit,
    swing: SwingAnalysis | Nil,
) => {
    const parameter =
        swing?.fullAnalysis?.data?.analysis?.parameter_values?.[parameterID] ??
        swing?.quickAnalysis?.data?.analysis?.parameter_values?.[parameterID];

    if (parameter) {
        const { unit, value } = parameter;
        const { value: convertedValue, symbol } = convertUnit({ unit, value, userPreferredUnit });
        return `${convertedValue}${symbol}`;
    }

    return '— ' + getDisplayUnitAndSymbol(parameterUnit, userPreferredUnit).symbol;
};
